export default {
  unavailable: {
    title: 'Ta usługa jest obsługiwana przez Foodamigos',
    description:
      'Drukowanie ulotek i naklejek to usługa obsługiwana przez zespół Foodamigos i nie jest dostępna dla kont partnerskich.',
  },
};
